import Vue from 'vue'
import Router from 'vue-router'
import Main from "@/components/Main/Main";
import Abouts from "@/components/Main/abouts";
import cooperation from "@/components/Main/cooperation";
import Apply from "@/components/Main/apply.vue"
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: "/",
      name: "Main",
      component: Main
    },
    {
      path: "/abouts",
      name: "abouts",
      component: Abouts 
    },
    {
      path: "/Cooperation",
      name: "Cooperation",
      component: cooperation,
      // children: [
      //   {
      //     path: "apply",
      //     name: "Apply",
      //     component: Apply
      //   }
      // ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js